'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var react = require('@emotion/react');
var theme_common_primitives_defaultPrimitives = require('../primitives/defaultPrimitives.js');
require('../primitives/commonPrimitives.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

/*
      ---------- BREAKPOINT TOKENS ----------
*/
function getBreakpointTokens(breakpoints) {
  var t = Object.values(breakpoints);
  t.xs = breakpoints.xs;
  t.sm = breakpoints.sm;
  t.md = breakpoints.md;
  t.lg = breakpoints.lg;
  t.xl = breakpoints.xl;
  t.mobile = t.xs;
  t.phablet = t.sm;
  t.tablet = t.md;
  t.desktop = t.lg;
  t.desktop_xl = t.xl;
  return t;
}
var commonBreakpoints = getBreakpointTokens(theme_common_primitives_defaultPrimitives.defaultBreakpointPrimitives);
/*
      ---------- MEDIA QUERIES ----------
*/
var biggerThan = function biggerThan(breakpoint) {
  return "(min-width: ".concat(breakpoint, ")");
};
var smallerThan = function smallerThan(breakpoint) {
  return "(max-width: ".concat(Number.parseInt(breakpoint) - 1, "px)");
};
function getMediaQueries(breakpoints) {
  var keys = Object.keys(breakpoints);
  return keys.reduce(function (prev, curr) {
    var _objectSpread2;
    return _objectSpread__default["default"](_objectSpread__default["default"]({}, prev), {}, (_objectSpread2 = {}, _defineProperty__default["default"](_objectSpread2, curr, smallerThan(breakpoints[curr])), _defineProperty__default["default"](_objectSpread2, "".concat(curr, "Min"), biggerThan(breakpoints[curr])), _objectSpread2));
  }, {});
}
var commonMediaQueries = getMediaQueries(theme_common_primitives_defaultPrimitives.defaultBreakpointPrimitives);
/*
      ---------- DEVICE SIZES ----------
*/
function getDeviceSizes(breakpoints) {
  return {
    mobile: {
      minWidth: 0,
      maxWidth: Number.parseInt(breakpoints.md)
    },
    desktop: {
      minWidth: Number.parseInt(breakpoints.md) + 1,
      maxWidth: null
    }
  };
}
function getMedia(breakpoints) {
  var deviceSizes = getDeviceSizes(breakpoints);
  var deviceKeys = Object.keys(deviceSizes);
  return deviceKeys.reduce(function (prev, curr) {
    var _deviceSizes$curr = deviceSizes[curr],
      minWidth = _deviceSizes$curr.minWidth,
      maxWidth = _deviceSizes$curr.maxWidth;
    return _objectSpread__default["default"](_objectSpread__default["default"]({}, prev), {}, _defineProperty__default["default"]({}, curr, function (deviceStyles) {
      return maxWidth ?
      /*#__PURE__*/
      /*#__PURE__*/
      react.css("@media only screen and (min-width: ", minWidth, "px) and (max-width: ", maxWidth, "px){",
      /*#__PURE__*/
      /*#__PURE__*/
      react.css.apply(void 0, _toConsumableArray__default["default"](deviceStyles)), ";}") :
      /*#__PURE__*/
      /*#__PURE__*/
      react.css("@media only screen and (min-width: ", minWidth, "px){",
      /*#__PURE__*/
      /*#__PURE__*/
      react.css.apply(void 0, _toConsumableArray__default["default"](deviceStyles)), ";}");
    }));
  }, {});
}
var commonMedia = getMedia(theme_common_primitives_defaultPrimitives.defaultBreakpointPrimitives);
function getAllMedia() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : theme_common_primitives_defaultPrimitives.defaultBreakpointPrimitives;
  return {
    breakpoints: getBreakpointTokens(breakpoints),
    mediaQueries: getMediaQueries(breakpoints),
    media: getMedia(breakpoints)
  };
}

exports.biggerThan = biggerThan;
exports.commonBreakpoints = commonBreakpoints;
exports.commonMedia = commonMedia;
exports.commonMediaQueries = commonMediaQueries;
exports.getAllMedia = getAllMedia;
exports.getDeviceSizes = getDeviceSizes;
exports.getMedia = getMedia;
exports.smallerThan = smallerThan;
//# sourceMappingURL=breakpoints.js.map
